<template>
  <v-container fluid>
    <el-mandate-step :step="step" />
    <v-card outlined class="mb-4 bg-none">
      <component
        :is="stepComponents[activestep].component"
        :readonly-form="stepComponents[activestep].readonly"
        class="tabComponent"
        @gotoStep="gotoStep"
      ></component>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import unsavedDataRoute from '@/mixins/unsavedDataRoute'

import MandateStep1 from './MandateStep1'
import MandateStep2 from './MandateStep2'
import MandateStep3 from './MandateStep3'
import MandateStep4 from './MandateStep4'
import MandateStep5 from './MandateStep5'

export default {
  name: 'NewMandate',

  mixins: [userRole, unsavedDataRoute],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: false,
      loading: false,
      formData: {},
      classifiers: [],
    }
  },
  computed: {
    ...mapGetters(['menuState']),
    modeReadonly() {
      return false
    },
    step() {
      return this.$route.params.step.toString() || '1'
    },
    getRouteName() {
      return this.$route.name
    },
    stepComponents() {
      return [
        {
          value: 1,
          title: 'Įgaliojimo duomenys',
          component: MandateStep1,
          readonly: false,
        },
        {
          value: 2,
          title: 'Įgaliojimo asmenys',
          component: MandateStep2,
          readonly: false,
        },
        {
          value: 3,
          title: 'Kontaktiniai duomenys',
          component: MandateStep3,
          readonly: false,
        },
        {
          value: 4,
          title: 'Peržiūra',
          component: MandateStep4,
          readonly: false,
        },
        {
          value: 5,
          title: 'Apmokėjimas',
          component: MandateStep5,
          readonly: false,
        },
      ]
    },
    activestep() {
      const index = this.stepComponents.findIndex((item) => {
        return item.value.toString() === this.step
      })
      return index > 0 ? index : 0
    },
  },
  created() {
    this.isMenuState()
  },
  methods: {
    isMenuState(){
      if(this.menuState == 'show_only_statements'){
        this.$router.push({
          name: 'savInfoPage',
          params: {
            type: 'showOnlyStatements',
          },
        })
      }
    },
    gotoStep(step) {
      this.$router.push({
        name: this.getRouteName,
        params: {
          step: step.step,
          id: step.id,
          parentId: step.parentId,
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped></style>
